'use client';

import { useEffect } from 'react';

/**
 * ThemeInitializer component - Sets the default theme to dark mode
 * This component ensures dark mode is always the default theme
 */
const ThemeInitializer = () => {
  useEffect(() => {
    // Check if a theme is already stored
    const storedTheme = localStorage.getItem('theme');
    
    // If no theme is stored, or if we want to force dark mode, set it to dark
    const theme = storedTheme || 'dark';
    
    // Always default to dark mode
    document.documentElement.setAttribute('data-bs-theme', 'dark');
    
    // Store dark as the default theme if nothing was stored
    if (!storedTheme) {
      localStorage.setItem('theme', 'dark');
    }
  }, []);
  
  return null; // This component doesn't render anything
};

export default ThemeInitializer; 